import { Routes } from '@angular/router';
import { GemeindeSucheComponent } from './gemeinde-suche/gemeinde-suche.component';
import { GemeindeListComponent } from './gemeinde-list/gemeinde-list.component';
import { GbGemeindeDetailComponent } from './gb-gemeinde-detail/gb-gemeinde-detail.component';

export const GemeindeRoutes: Routes = [
  {
    path: 'gemeinde',
    loadChildren: () => routes
  }
];

const routes: Routes = [
  {
    path: '',
    component: GemeindeSucheComponent,
    data: {
      breadcrumb: 'gemeinde.breadcumbSuche',
      breadcrumbStatus: 'firstLevel'
    }
  },
  {
    path: 'list/:searchMode',
    component: GemeindeListComponent,
    data: {
      breadcrumb: 'Suchergebnis',
      breadcrumbStatus: 'secondLevel'
    }
  },
  {
    path: 'gb/detail/:id',
    component: GbGemeindeDetailComponent
  }
];
